module.exports = __webpack_public_path__ + "static/3-5eaa23067998c1f02a945aeab250f77f.jpg";